export const axiosParamsSerialiser = (params: Record<string, any>) =>
    Object.entries(params)
        .filter((entry) => ![undefined, null].includes(entry[1]))
        .map(([key, value]) => {
            if (Array.isArray(value))
                return value.map((val) => `${key}=${val}`).join("&");
            return `${key}=${value}`;
        })
        .join("&");
